namespace TabAurous.Production {
    export interface ReceiptMaterialItemsRow {
        TransItemId?: number;
        TransDetailId?: number;
        BagNo?: string;
        SubBagNo?: number;
        LotNo?: string;
        OldBagNo?: string;
        Line_No?: number;
        OldLineNo?: number;
        DepartmentId?: number;
        ProductId?: number;
        ToProductId?: number;
        ToAttributeId?: number;
        ProductCode?: string;
        HSN?: string;
        TaxCode?: string;
        SKU?: string;
        AttributeId?: number;
        Attribute?: string;
        ItemTypeId?: number;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        NetWeight?: number;
        Purity?: number;
        PureWeight?: number;
        Rate?: number;
        Amount?: number;
        DeliveryDate?: string;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: Common.StoneStatus;
        Lab?: string;
        CertificateNo?: string;
        ProductTypeId?: number;
        KaratId?: number;
        MetalColorId?: number;
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        StockAllocation?: boolean;
        KaratName?: string;
        MetalColorName?: string;
        StoneSizeName?: string;
        ShapeName?: string;
        SieveName?: string;
        QualityName?: string;
        StoneColoreName?: string;
    }

    export namespace ReceiptMaterialItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.ReceiptMaterialItems';
        export const deletePermission = 'Production:ReceiptMaterial:Delete';
        export const insertPermission = 'Production:ReceiptMaterial:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:ReceiptMaterial:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransDetailId = "TransDetailId",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            LotNo = "LotNo",
            OldBagNo = "OldBagNo",
            Line_No = "Line_No",
            OldLineNo = "OldLineNo",
            DepartmentId = "DepartmentId",
            ProductId = "ProductId",
            ToProductId = "ToProductId",
            ToAttributeId = "ToAttributeId",
            ProductCode = "ProductCode",
            HSN = "HSN",
            TaxCode = "TaxCode",
            SKU = "SKU",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            ItemTypeId = "ItemTypeId",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            NetWeight = "NetWeight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            Rate = "Rate",
            Amount = "Amount",
            DeliveryDate = "DeliveryDate",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefVoucherId = "RefVoucherId",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            ProductTypeId = "ProductTypeId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            StockAllocation = "StockAllocation",
            KaratName = "KaratName",
            MetalColorName = "MetalColorName",
            StoneSizeName = "StoneSizeName",
            ShapeName = "ShapeName",
            SieveName = "SieveName",
            QualityName = "QualityName",
            StoneColoreName = "StoneColoreName"
        }
    }
}
